import * as Yup from "yup";

import { validationMsgs } from "@sso/constant";
import { LicenceKeys, LicenceType } from "@sso/types";

export const licenceSchemeValidation = Yup.object({
  [LicenceKeys.SOFTWARE_ID]: Yup.string().required(validationMsgs.required),
  [LicenceKeys.SOFTWARE_LICENCE_ID]: Yup.string().required(validationMsgs.required),
  [LicenceKeys.EXPIRY_DATE]: Yup.string().when("neverExpire", {
    is: false || undefined,
    then: Yup.string().required(validationMsgs.required),
    otherwise: Yup.string(),
  }),
  neverExpire: Yup.boolean(),
  [LicenceKeys.ORGANISATION_ID]: Yup.string().required(validationMsgs.required),
  [LicenceKeys.TYPE]: Yup.string().required(validationMsgs.required),
  [LicenceKeys.USER_ID]: Yup.string().when(LicenceKeys.TYPE, {
    is: LicenceType.SINGLE_USER.toString(),
    then: Yup.string().required(validationMsgs.required),
  }),
  [LicenceKeys.CONCURRENT_USERS]: Yup.string().when(LicenceKeys.TYPE, {
    is: LicenceType.CONCURRENT.toString(),
    then: Yup.string().required(validationMsgs.required).nullable(),
  }),

  // Tracc-specific validations
  Tracc_HardwareId: Yup.string().when([LicenceKeys.SOFTWARE_LICENCE_ID], {
    is: (softwareLicenceId: string | undefined) => {
      return softwareLicenceId?.toUpperCase() === process.env.REACT_APP_TRACC_SINGLE_ID?.toUpperCase() ||
        softwareLicenceId?.toUpperCase() === process.env.REACT_APP_TRACC_CONCURRENT_ID?.toUpperCase();
    },
    then: Yup.string().required(validationMsgs.required),
    otherwise: Yup.string().nullable()
  }),

  Tracc_ServerAddress: Yup.string().when([LicenceKeys.SOFTWARE_LICENCE_ID], {
    is: (softwareLicenceId: string | undefined) => {
      return softwareLicenceId?.toUpperCase() === process.env.REACT_APP_TRACC_SINGLE_ID?.toUpperCase() ||
        softwareLicenceId?.toUpperCase() === process.env.REACT_APP_TRACC_CONCURRENT_ID?.toUpperCase();
    },
    then: Yup.string().nullable(), // Optional for now, change to required() if needed
    otherwise: Yup.string().nullable()
  }),

  Tracc_Description: Yup.string().when([LicenceKeys.SOFTWARE_LICENCE_ID], {
    is: (softwareLicenceId: string | undefined) => {
      return softwareLicenceId?.toUpperCase() === process.env.REACT_APP_TRACC_SINGLE_ID?.toUpperCase() ||
        softwareLicenceId?.toUpperCase() === process.env.REACT_APP_TRACC_CONCURRENT_ID?.toUpperCase();
    },
    then: Yup.string().nullable(), // Optional for now, change to required() if needed
    otherwise: Yup.string().nullable()
  }),
});